import { Tab, Tabs } from '@material-ui/core'
import { AddWorkingStepButton } from 'components/ProjectPage/BillOfMaterials/Rows/Components/RowWorkingSteps/WorkingSteps/BomWorkingStepsList'
import { useBomItemPricePerBatchStyles } from 'features/BillOfMaterials/components/BomItemPricePerBatch'
import { ProjectStatusSelector } from 'features/BillOfMaterials/components/ProjectStatus/ProjectStatus'
import { ProjectBatchSizeInput } from 'features/BillOfMaterials/ProjectHeader/ProjectBatchSizeInput'
import {
  ProjectDiscountRatio,
  ProjectSurchargeRatio,
} from 'features/BillOfMaterials/ProjectHeader/ProjectDiscountOrSurcharge'
import { ProjectGrossSalesPrice } from 'features/BillOfMaterials/ProjectHeader/ProjectGrossSalesPrice'
import { ProjectNetSalesPrice } from 'features/BillOfMaterials/ProjectHeader/ProjectNetSalesPrice'
import { ProjectOrderNumberInput } from 'features/BillOfMaterials/ProjectHeader/ProjectOrderNumberInput'
import { ProjectPricePerBatch } from 'features/BillOfMaterials/ProjectHeader/ProjectPricePerBatch'
import { ProjectReferenceInput } from 'features/BillOfMaterials/ProjectHeader/ProjectReferenceInput'
import { BomItemRoutingData } from 'features/BillOfMaterials/RoutingHeader/RoutingData'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBomItemDetailsDrawerStyles } from '../../BomItemDetailsDrawer.styles'
import { BomItemTargetPriceInput } from '../../Inputs/BomItemTargetPriceInput'
import { BomItemPriceContainer } from '../BomItemPriceContainer'
import { ProjectFinancialDetails } from './ProjectFinancialDetails'
import { ProjectGraphsContainer } from './ProjectGraphsContainer'

export type BomItemDetailsProps = {
  bomItemId: string
  bomItemType: BoMItemType
  loading?: Record<string, boolean>
  detailTabIndex?: number
}

// type PriceSummaryDetailsViews = 'priceSummary' | 'projectWorkingSteps'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index ? children : null}
    </div>
  )
}

export const ProjectDetails = (props: BomItemDetailsProps) => {
  const sharedClasses = useBomItemDetailsDrawerStyles()
  const priceClasses = useBomItemPricePerBatchStyles( { fullWidth: false})
  const { t } = useTranslation()

  // const [view, setView] = useState<PriceSummaryDetailsViews>('priceSummary')
  const [viewIndex, setViewIndex] = useState<number>(props.detailTabIndex ?? 0)

  // const handleChangeView = (view: PriceSummaryDetailsViews) => {
  //   setView(view)
  // }

  return (
    <>
      <div className={sharedClasses.bomItemDescription}>
        <div
          className={sharedClasses.description}
          style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}
        >
          <ProjectReferenceInput
            textFieldProps={{
              fullWidth: true,
            }}
          />
          <ProjectOrderNumberInput textFieldProps={{ fullWidth: true }} />
          <ProjectStatusSelector />
          <div className={sharedClasses.prices}>
            <BomItemTargetPriceInput
              bomItemId={props.bomItemId}
              priceScope={'perUnit'}
              textFieldProps={{
                className: priceClasses.moneyTextField,
                inputProps: {
                  style: {
                    textAlign: 'right',
                    width: '90px',
                  },
                },
              }}
            />
            <ProjectBatchSizeInput />
            <ProjectPricePerBatch />
            <ProjectGrossSalesPrice />
            <ProjectSurchargeRatio />
            <ProjectDiscountRatio />
            <ProjectNetSalesPrice />
          </div>
        </div>
      </div>
      <div className={sharedClasses.unitSelector}>
        <AddWorkingStepButton
          bomItemType={BoMItemType.project}
          rowIds={[props.bomItemId]}
        />
        <BomItemRoutingData
          bomItemId={props.bomItemId}
          rootClassName={sharedClasses.workingSteps}
        />
      </div>
      <Tabs
        value={viewIndex}
        onChange={(_, value) => {
          setViewIndex(value)
        }}
        textColor="primary"
        indicatorColor="primary"
        variant="fullWidth"
        className={sharedClasses.tabs}
      >
        <Tab label={t('project:project-totals', 'project totals')} />
        <Tab
          label={t('project:project-working-steps', 'project working steps')}
        />
        <Tab label={t('project:vertical-menu-margin-label')} />
      </Tabs>
      <div className={sharedClasses.detailsContainer}>
        <TabPanel value={viewIndex} index={0}>
          <ProjectFinancialDetails />
        </TabPanel>
        <TabPanel value={viewIndex} index={1}>
          <BomItemPriceContainer
            bomItemId={props.bomItemId}
            bomItemType={props.bomItemType}
          />
        </TabPanel>
        <TabPanel value={viewIndex} index={2}>
          <ProjectGraphsContainer />
        </TabPanel>
      </div>
      {/* <ButtonGroup fullWidth>
        <Button
          onClick={() => handleChangeView('priceSummary')}
          variant={view === 'priceSummary' ? 'contained' : 'outlined'}
          color="primary"
        >
          Price Summary
        </Button>
        <Button
          color="primary"
          onClick={() => handleChangeView('projectWorkingSteps')}
          variant={view === 'projectWorkingSteps' ? 'contained' : 'outlined'}
        >
          Project Working Steps
        </Button>
      </ButtonGroup>
      <div className={sharedClasses.detailsContainer}>
        {view === 'priceSummary' ? (

        ) : (
          <BomItemPriceContainer
            bomItemId={props.bomItemId}
            bomItemType={props.bomItemType}
          />
        )}
      </div> */}
    </>
  )
}
